import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Files, Bookmark, LogOut, User, Skull, BarChart3, Vote } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 border-b border-[#333] bg-[#0A0A0A]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <Skull className="h-6 w-6 text-[#D92D20]" strokeWidth={1.5} />
          <div className="leading-none">
            <div className="font-heading text-xl tracking-tight text-white">THE ARCHIVE</div>
            <div className="meta-label mt-0.5">Controversy / Declassified</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/"
            data-testid="nav-archive"
            className="meta-label nav-link hover:text-white"
          >
            <Files className="h-4 w-4" strokeWidth={1.5} /> <span className="hidden sm:inline">Archive</span>
          </Link>

          {user ? (
            <>
              <Link
                to="/bookmarks"
                data-testid="nav-bookmarks"
                className="meta-label nav-link hover:text-[#FBBF24]"
              >
                <Bookmark className="h-4 w-4" strokeWidth={1.5} /> <span className="hidden sm:inline">Saved</span>
              </Link>
              <Link
                to="/my-votes"
                data-testid="nav-votes"
                className="meta-label nav-link hover:text-[#3B82F6]"
              >
                <Vote className="h-4 w-4" strokeWidth={1.5} /> <span className="hidden sm:inline">Votes</span>
              </Link>
              {user.role === "admin" && (
                <Link
                  to="/admin"
                  data-testid="nav-dashboard"
                  className="meta-label nav-link hover:text-[#22C55E]"
                >
                  <BarChart3 className="h-4 w-4" strokeWidth={1.5} /> <span className="hidden sm:inline">Dashboard</span>
                </Link>
              )}
              <span className="meta-label hidden items-center gap-2 text-[#737373] md:flex">
                <User className="h-4 w-4" strokeWidth={1.5} /> {user.name || user.email}
              </span>
              <button
                data-testid="logout-btn"
                onClick={logout}
                aria-label="Log out"
                className="meta-label nav-link border border-[#333] hover:border-[#D92D20]/50 hover:text-white"
              >
                <LogOut className="h-4 w-4" strokeWidth={1.5} />
              </button>
            </>
          ) : (
            <button
              data-testid="nav-login"
              onClick={() => navigate("/login")}
              className="btn-cta px-5 py-2"
            >
              Access
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};
